import { z } from 'zod';

export const benchmarkingFiltersSchema = z.object({
  escola: z.coerce.number().optional(),
  serie: z.coerce.number().optional(),
  turma: z.coerce.number().optional(),
  aluno: z.coerce.number().optional(),
  categoria: z.coerce.number().optional(),
  modelo: z.string().optional(),
});

export type BenchmarkingUrlFilters = z.infer<typeof benchmarkingFiltersSchema>;
